import { createAction } from '@reduxjs/toolkit';

export const HTMLSnippetActions = {
  notification: createAction<{ customMessage: string }>('HTMLSnippet/Notification'),
};
